import grapesjs from 'grapesjs';
import loadBlocks from './blocks';
import loadComponents from './components';

export default grapesjs.plugins.add('gjs-form-input', (editor, opts = {}) => {
  const config = {
    blocks: [
      'formInput',
    ],
    name: 'formInput',
    stylePrefix: 'gjs-',
    labelFormInput: 'Entrada de Texto',
    defText: 'Sample',
    category: 'Formularios',
    ...opts,
  };
  // eslint-disable-next-line no-restricted-syntax
  for (const name in config) {
    if (!(name in opts)) opts[name] = config[name];
  }

  loadBlocks(editor, config);
  loadComponents(editor, opts);
});
